import { ROLE_TYPES } from '@digitale-verhuurders-verklaring/core/src/models/functions/authentication/types';
import {
  CaseStep,
  DeclarationStep,
} from '@digitale-verhuurders-verklaring/core/src/models/shared/dynamoDB/types';
import { RouteLocationNormalized } from 'vue-router';

import {
  currentUserQueryKey,
  currentUserRolesAsEnum,
  fetchCurrentUser,
} from '../queries/getCurrentUser';
import { getOldestActionableCaseForTenant } from '../queries/getOldestActionableCaseForTenant';
import { queryClient } from '../queryClient';
import routes from './routes';

export const handleRedirectBasedOnRole = async (
  to:
    | RouteLocationNormalized
    | { name: string; params: Record<string, string> },
): Promise<object> => {
  try {
    const currentUser = await queryClient.ensureQueryData({
      queryKey: currentUserQueryKey,
      queryFn: fetchCurrentUser,
    });
    const userRoles = currentUserRolesAsEnum(currentUser.roles);
    // Redirect to request form if user is tenant if they are navigating to another route or requestCurrentLandlord/tenantCheck without a caseId
    if (
      userRoles.includes(ROLE_TYPES.TENANT) &&
      !(
        (to.name === routes.requestCurrentLandlord ||
          to.name === routes.tenantCheck) &&
        to.params.caseId
      )
    ) {
      //We dont have the caseId so we need to get the oldest actionable case for the tenant
      const oldestCase = await getOldestActionableCaseForTenant();

      // If no case is found, redirect to tenantDashboard
      if (!oldestCase || oldestCase.reIssueDeclarationId) {
        return { name: routes.tenantDashboard };
      }

      // If the previous step was tenant, redirect to requestCurrentLandlord
      if (oldestCase.step === CaseStep.NEW_LANDLORD_REQUEST) {
        return {
          name: routes.requestCurrentLandlord,
          params: { caseId: oldestCase.caseId },
        };
      }

      // If the previous step was current landlord, redirect to tenantCheck
      if (oldestCase.step === DeclarationStep.CURRENT_LANDLORD) {
        return {
          name: routes.tenantCheck,
          params: { caseId: oldestCase.caseId },
        };
      }

      // Only redirect to tenantDashboard if not already there
      if (to.name !== routes.tenantDashboard) {
        return { name: routes.tenantDashboard };
      }
    }

    if (
      userRoles.includes(ROLE_TYPES.READER) ||
      userRoles.includes(ROLE_TYPES.LOCATION_ADMIN) ||
      userRoles.includes(ROLE_TYPES.ASSESSOR) ||
      userRoles.includes(ROLE_TYPES.REQUESTER) ||
      (userRoles.includes(ROLE_TYPES.ISSUER) &&
        !(to.name === routes.currentLandlordAssessment && to.params.caseId))
    ) {
      return { name: routes.dashboard };
    }

    if (userRoles.includes(ROLE_TYPES.ADMIN)) {
      return { name: routes.settingsOrganisation };
    }

    if (to.name !== routes.home) {
      return { name: routes.home };
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  //eslint-disable-next-line no-undefined
  return { name: routes.home };
};
